import { parseLocaleNumber } from "./decimal";

function toFiniteNumber(value, fallback = 0) {
  const number = parseLocaleNumber(value);
  return Number.isFinite(number) ? number : fallback;
}

export function hasConfiguredReorderPoint(item) {
  return toFiniteNumber(item?.reorder_point) > 0;
}

export function isBelowReorderPoint(item) {
  return (
    hasConfiguredReorderPoint(item)
    && toFiniteNumber(item?.current_quantity) <= toFiniteNumber(item?.reorder_point)
  );
}

export function getReorderRatio(item) {
  if (!hasConfiguredReorderPoint(item)) return Number.POSITIVE_INFINITY;
  return toFiniteNumber(item?.current_quantity) / toFiniteNumber(item?.reorder_point);
}
